import { Box, useTheme } from "@mui/material";
import { useTranslation } from 'react-i18next';
import ShLabel from "../../../../components/theme/label/ShLabel";
import Text from "../../../../components/theme/text/Text";
import { tokens } from "../../../../theme";

import React, { useEffect, useRef, useState } from "react";
import OrdersCard from "../../../../components/global/cards/orders/OrdersCard";
import ShDataGrid2 from "../../../../components/theme/datagrid2/ShDataGrid2";
import ShCopyButton from '../../../../components/theme/ShCopy';
import SidepanelLoader from "../../../../components/theme/sidepanel2/SidepanelLoader";
import ShLabelSkeleton from "../../../../components/theme/skeleton/ShLabelSkeleton";
import ShTextSkeleton from "../../../../components/theme/skeleton/ShTextSkeleton";
import { useGetAllOrderLinesQuery, useExportOrderLinesMutation } from "../../../../newapi/order/ordersSlice";
import { getOrderStateData } from "../../../../utils/labelColorText";
import { general_states } from "../../../../utils/staticEnums";
import { ORDER_FILTER_KEYS } from "../../../../components/global/DataGrid/Filter";
import ButtonGroup from "../../../../components/theme/buttons/ButtonGroup";
import Shbutton from "../../../../components/theme/buttons/Shbutton";
import { showToastPromise } from "../../../../utils/toasts";
import { DownloadOutlined } from "@mui/icons-material";
import { RELATION_ORDERS_DEFAULT } from "../../../../components/theme/datagrid3/groupingPresets/GroupingPresets";
import ShDataGrid3 from "../../../../components/theme/datagrid3/ShDataGrid3";
import { RELATION_ORDERS_LINES } from "../family";

const SpOrderDetails = SidepanelLoader(() => import("../../../../components/global/Sidepanels/SpOrderDetails/SpOrderDetails"));

const GridActions = (props) => {
    const theme = useTheme();
    const {t} = useTranslation();
    return <ButtonGroup version={2}>
            <Shbutton 
                    className={"group-btn"} 
                    color={theme.palette.mode === "dark" ? "primaryGrey" : "grey"} 
                    onClick={() => props.exportProducts()}
                    endIcon={<DownloadOutlined/>}
                    variant="contained"
                    isLoading={props.isExporting}
                >
                    {t("export")}
                </Shbutton>
        </ButtonGroup>
        
}

let gridOptions = {
    export:true,
    disableCustomActionsOnPhone: true,
    isSidepanel: true,
    filter: [ORDER_FILTER_KEYS.PRODUCT],

};

const OutboundOrderlines = (props) => {
    const { t, i18n } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [isExtended, setIsExtended] = useState(false);
    const [spLoading, setSpLoading] = useState();
    
    const [config, setConfig] = useState({});

    // const { index,id } = useGridFilter();

    // const filterObject = useSelector((state) => {
    //     const instance = state.gridFilter.viewInstances[index];
    //     return instance ? instance[id] : undefined;
    // });
    const [filter, setFilter] = useState({});
    const [exportOrderLines, {isLoading: isExporting}] = useExportOrderLinesMutation();
    const exportOrdersCall = async () => {  
        const exportPromise = exportOrderLines(filter).unwrap();

        showToastPromise(
            exportPromise,
            t,
            {
                pending: t('export_processing') || 'Processing export...',
                success: t('export_success') || 'Export completed successfully',
                error: t('export_failed') || 'Export failed'
            }
        ).then((result) => {
            if (result.processing) {
                console.log('Export is being processed in background. Export ID:', result.exportId);
            }
        }).catch((error) => {
            console.error("Export failed", error);
        });
    }

    useEffect(() => {
        props.replaceView({
            ...props.config,
            gridOptions: gridOptions,
            mobileActions: <GridActions isExporting={isExporting} 
            exportProducts={exportOrdersCall}></GridActions>,
        });

        return () => {
            // console.log("unmounting warehouse");
        }
    },[config,isExporting,exportOrdersCall]);

    const [orderId, setOrderId] = useState();
    const orderIdRef = useRef(orderId);
    
    const getOrderDetails = (params) => {
        if (!params) return;
    
        const neworderId = parseInt(params.row.order.id);
        // Only update state if the orderId has actually changed
        if (orderIdRef.current !== neworderId) {
            
            if(!spLoading) {
                setSpLoading(true);
            }
            setOrderId(neworderId);
            orderIdRef.current = neworderId; // Update the ref to the new value
        }
        setIsExtended(true);
    };

    const columns = [
        {
            field: "barcode",
            headerName: t('order'),
            flex:1,
            sortable: false,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                return (
                    <Box sx={{
                        minWidth:"100%",
                        height:"100%",
                        display:"flex",
                        alignItems:"center",
                        position:"relative",
                        whiteSpace:"nowrap",
                        wordBreak:"keep-all",
                        textOverflow:"ellipsis",
                        overflow:"hidden",
                        ".copyel": {
                            opacity:0,
                        },
                        "&:hover .copyel": {
                            opacity:1,
                        }
                    }}>
                        <Text noBreak>{params.row.order.barcode}</Text>
                        <ShCopyButton 
                            styles={{button:{
                                background:theme.palette.mode === "dark" ? colors.grey[600] :  colors.grey[200],
                                color: colors.txt["primary"],
                                "&:hover" : {
                                    background:theme.palette.mode === "dark" ? colors.grey[500] :colors.grey[300],

                                }
                            }}} 
                            sx={{position:"absolute",right:0,zIndex:3000}} 
                            className={"copyel"} 
                            closeAfter={1500} 
                            value={params.row.barcode}
                        ></ShCopyButton>
                    </Box>
                );
            }
        },
        {field: "webshopreference", headerName: t("webshopreference"),flex:1, sortable: false,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                return (<Text>{`${params.row.order.webshopreference} (${params.row.order.deliveryCountry ? params.row.order.deliveryCountry.toUpperCase() : ""})`}</Text>)
            }
        },
        {field: "sku", headerName: t("sku"),flex:1, sortable:false,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
               return params.row.product.sku;
            }
        },
        {field: "description", headerName: t("description"),flex:3, sortable:false,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
               return params.row.product.description;
            }
        },
        {field: "amount", headerName: t("amount"),flex:1, sortable: false,
        renderCell: (params) => {
            if(params.row.skeleton) {
                return <ShTextSkeleton/>
            }
            return params.row.amount
        }},
        {
            field: "date_planned", 
            headerName: t("date_planned_shipment"),
            flex:1,
            sortable: false,
            shFilter: {
                type: "date"
            },
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShLabelSkeleton/>
                }
                
                let planned = new Date(params.row.order.date_planned);
                let sent = params.row.order.date_sent ? new Date(params.row.order.date_sent) : null;
              
                return (
                    <ShLabel size={32} fitted variant="blue" palette="normal">
                        {!sent && planned.toLocaleDateString(i18n.language)}
                        {sent && sent.toLocaleDateString(i18n.language)}
                    </ShLabel>
                );
            }
        },
        // {field: "shipper", headerName: t("shipper_name"),flex:1,
        // renderCell: (params) => {
        //     if(params.row.skeleton) {
        //         return <ShTextSkeleton/>
        //     }
        //     return params.row.shipper?.name
        // }},
        {
            field: "state", 
            headerName: t("state"),
            flex:1,
            sortable: false,
            shFilter: {
                type: "date"
            },
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShLabelSkeleton/>
                }

                const { labelcolor, labeltext } = getOrderStateData(params.row.order.state, theme, true, params.row.order.snoozeWhenAvailable);
              
                return (
                    <ShLabel size={32} palette="normal" variant={labelcolor}>
                      {t(labeltext)}
                    </ShLabel>
                  );
              }
        },
        {
            field: "createdAt", 
            headerName: t("date_created"),
            flex:1,
            sortable: false,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                const date = new Date(params.row.createdAt);
                const dateStr = date.toLocaleDateString(i18n.language, { dateStyle: 'short' });
                const timeStr = date.toLocaleTimeString(i18n.language, { timeStyle: 'short' });

                return (
                    <Text>
                        {dateStr}{' '}<Text light>{timeStr}</Text>
                    </Text>
                );
            },
            grouping: RELATION_ORDERS_DEFAULT.CREATED_AT,
        },
        {
            field: "phoneView", 
            headerName: "PhoneView",
            cellClassName: "phone-column--cell",
            renderCell: (params) => {
                return (
                    <OrdersCard onClick={() => getOrderDetails(params)} skeleton={params.row.skeleton ?? false} {...params.row}  />
                )
            }
        }
    ];

    return (
        <Box height={1} display={"flex"} flexDirection={"column"}>
            {/* <GridActions></GridActions> */}
            <ShDataGrid3
                key={theme.palette.mode}
                content={useGetAllOrderLinesQuery}
                gridKey={RELATION_ORDERS_LINES.LINES.gridKey}
                enableGrouping={true}
                config={config}
                gridActions={<GridActions  isExporting={isExporting} exportProducts={exportOrdersCall}></GridActions>} 
                title={t('orderlines') }
                gridOptions={gridOptions} 
                filterObjectChanged={(filterObject) => {
                    setFilter(filterObject?.filter);
                }}
                sortModel={{field: columns[7].field,type:"DESC"}}
                columns={columns}
                // rows={data}
                onRowClick={getOrderDetails}
            >
            </ShDataGrid3>

            {spLoading && 
                <SpOrderDetails
                    isExtended={isExtended}
                    setIsExtended={setIsExtended}
                    orderId={orderId}
                    // data={orderData}
                    // relation={true}
                    canReserveOrderLines={true}
                />
            }
        </Box>
    );
}
export default OutboundOrderlines;